import { useAlerter } from 'lib/hooks';

interface UseHandleServerErrorArgs {
  setErrorFunc?: Function;
  unknownErrorMessage?: string;
  validationErrorMessage?: string;
}

export default function useHandleServerError({
  setErrorFunc = () => {},
  unknownErrorMessage = 'Oops, something went wrong',
  validationErrorMessage = 'Please correct the indicated problems and try again'
}: UseHandleServerErrorArgs = {}) {
  const { popError, showError } = useAlerter();

  const handleValidationErrors = modelMutationResult => {
    if (!modelMutationResult.success) {
      modelMutationResult.errors.forEach(error => {
        setErrorFunc(error.attribute === 'base' ? 'root' : error.attribute, {
          type: 'serverValidation',
          message: error.message
        });
      });
      popError(validationErrorMessage, null, {
        toastId: 'validation-error'
      });
    }
    return modelMutationResult.success;
  }

  function showSubscriptionError(subscriptionError) {
    const { message, extensions } = subscriptionError;
    const action = extensions.subscribed ? 'Upgrade' : 'Subscribe';
    const messageElement = <>{message} <a href="/subscription">{action} now</a></>;
    showError(messageElement, null, { toastId: 'subscription-required' });
  }

  const handleServerError = err => {
    console.log(err);

    const subscriptionError = err.graphQLErrors?.find(
      e => e.extensions?.code === 'SUBSCRIPTION_REQUIRED'
    );

    if (subscriptionError) {
      showSubscriptionError(subscriptionError);
    } else {
      popError(unknownErrorMessage, null, {
        toastId: 'unknown-error'
      });
    }
  }

  return { handleValidationErrors, handleServerError };
}
